import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=0412977e&scoped=true&"
var script = {}
import style0 from "./dialog.vue?vue&type=style&index=0&id=0412977e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412977e",
  null
  
)

export default component.exports